export type CanvasPoint = {
  x: number;
  y: number;
};

export type ActiveRectangle = {
  start: CanvasPoint;
  edgeEnd: CanvasPoint | null;
  pointer: CanvasPoint;
};

export type ActiveCircle = {
  center: CanvasPoint;
  pointer: CanvasPoint;
};

const getDistance = (pointA: CanvasPoint, pointB: CanvasPoint) =>
  Math.hypot(pointB.x - pointA.x, pointB.y - pointA.y);

export const buildRectanglePolyline = (rectangle: ActiveRectangle) => {
  if (!rectangle.edgeEnd) return null;

  const baseDx = rectangle.edgeEnd.x - rectangle.start.x;
  const baseDy = rectangle.edgeEnd.y - rectangle.start.y;
  const baseLength = Math.hypot(baseDx, baseDy);
  if (baseLength === 0) return null;

  const normalX = -baseDy / baseLength;
  const normalY = baseDx / baseLength;
  const offset =
    (rectangle.pointer.x - rectangle.start.x) * normalX +
    (rectangle.pointer.y - rectangle.start.y) * normalY;

  const thirdPoint = {
    x: rectangle.edgeEnd.x + normalX * offset,
    y: rectangle.edgeEnd.y + normalY * offset,
  };
  const fourthPoint = {
    x: rectangle.start.x + normalX * offset,
    y: rectangle.start.y + normalY * offset,
  };

  return [
    rectangle.start.x,
    rectangle.start.y,
    rectangle.edgeEnd.x,
    rectangle.edgeEnd.y,
    thirdPoint.x,
    thirdPoint.y,
    fourthPoint.x,
    fourthPoint.y,
  ];
};

export const getActiveCircleRadius = (circle: ActiveCircle) =>
  getDistance(circle.center, circle.pointer);

export const buildSinglePointCircleState = (
  center: CanvasPoint,
  radius: number,
): ActiveCircle => ({
  center,
  pointer: {
    x: center.x + radius,
    y: center.y,
  },
});
